import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { ReactComponent as AIIcon } from 'assets/icons/AIIcon.svg';

import { useBreakpoints } from 'hooks/media/useBreakpoints';

import { Button } from 'components/_basic/Button/Button';
import { Modal } from 'components/_basic/Modal';

import { IAIGenerationErrorModalProps } from './types';

import styles from './AIGenerationErrorModal.module.scss';

export const AIGenerationErrorModal: React.FC<IAIGenerationErrorModalProps> = ({ close, errorMessage, click }) => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoints();

  const handleButtonClick = () => {
    if (click) {
      click();
      return;
    }
    close();
  };

  return (
    <Modal maxWidth={false} className={styles.modal} close={close}>
      <DialogTitle>
        {errorMessage === 'NOT_ENOUGH_CONTEXT' ? (
          <Box display={'flex'} gap={1}>
            <AIIcon />
            {t('aiAssistantAlertCard.title4')}
          </Box>
        ) : (
          t('aiGenerationErrors.oops')
        )}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {errorMessage === 'NOT_ENOUGH_CONTEXT' ? t('completeKeyFields') : t('somethingWentWrong')}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ paddingTop: 2 }}>
        {isMobile && errorMessage === 'NOT_ENOUGH_CONTEXT' ? (
          <Button color="primary" variant="outlined" size="small" onClick={handleButtonClick}>
            {t('aiAssistantAlertCard.goToRequiredFields')}
          </Button>
        ) : (
          <Button color="primary" variant="outlined" size="small" onClick={close}>
            {t('aiGenerationErrors.okay')}
          </Button>
        )}
      </DialogActions>
    </Modal>
  );
};
